export default {
  "content": "<path d=\"M8.5 6A1.5 1.5 0 007 7.5v35a1.5 1.5 0 103 0V33h31.5a1.5 1.5 0 001.2-2.4l-8.33-11.1L42.7 8.4A1.5 1.5 0 0041.5 6h-33z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 48 48"
  }
};